const createCopy = (values = {}) => JSON.parse(JSON.stringify(values));

const removeNonFormProperties = (values = {}) => {
  const result = {};
  const PROPERTIES_BLACKLIST = ['meta'];
  for (let value in values) {
    if (!PROPERTIES_BLACKLIST.includes(value)) {
      result[value] = values[value];
    }
  }
  return result;
};

const createFromKeys = (values = {}) => {
  const result = {};
  Object.keys(values).forEach((key) => (result[key] = ""));
  return result;
};

export const objectHelper = {
  createCopy,
  createFromKeys,
  removeNonFormProperties,
};



// WEBPACK FOOTER //
// ./src/_shared/utils/objectHelper.js